import { Box, Divider, gridClasses, Stack, Typography } from '@mui/material';
import { DataGridPro, GridValidRowModel } from '@mui/x-data-grid-pro';
import { isNotNil } from 'ramda';

import { DataGridConfig } from '@/legacy/components/DataGridCustom';

type GroupedResults<T> = {
  title: string;
  row: T[];
}[];

export const ResultsTableCard = <T,>({
  results,
  config,
}: {
  results: T[] | GroupedResults<T>;
  config: DataGridConfig<T extends GridValidRowModel ? T : never, any, any>;
}) => {
  // Handle grouped array results
  if (results.every((row) => typeof row === 'object' && isNotNil(row) && 'title' in row)) {
    return (
      <Stack spacing={3} divider={<Divider />}>
        {(results as GroupedResults<T>).map((group, index) => (
          <Box key={`${group.title}-${index}`}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              {group.title}
            </Typography>
            <DataGridPro
              {...config}
              rows={(group.row as (T extends GridValidRowModel ? T : never)[]) || []}
              getRowId={(row) => row.id}
              sx={{
                [`&.${gridClasses.root}`]: {
                  '--DataGrid-containerBackground': 'transparent',
                },
              }}
              hideFooter
              disableColumnMenu
              density="compact"
            />
          </Box>
        ))}
      </Stack>
    );
  }

  // Render flat array results
  return (
    <DataGridPro
      {...config}
      rows={(results as (T extends GridValidRowModel ? T : never)[]) || []}
      getRowId={(row) => row.id}
      sx={{
        [`&.${gridClasses.root}`]: {
          '--DataGrid-containerBackground': 'transparent',
        },
      }}
      hideFooter
      disableColumnMenu
      density="compact"
    />
  );
};
